export default "__VITE_ASSET__X2jwwJDv__"